import { ContractOP, RmsContractBalance } from '@cemex-core/cmx-api';
import { AdtContractActions, AdtContractActionTypes } from '../../actions/contracts.actions';

/**
 * Admixtures Contracts Store Interface
 */
export interface ContractsState {
    loading: boolean;
    productContracts: { [productCode: string]: ContractOP[] };
    contractBalances: { [productCode: string]: RmsContractBalance[] };
    contractSelected: ContractOP;
}

/**
 * Initial state of Admixtures Contracts Store
 */
export const initialState: ContractsState = {
    loading: false,
    productContracts: undefined,
    contractBalances: undefined,
    contractSelected: undefined,
};

/**
 * Admixture contracts reducer
 * @param {ContractsState} state
 * @param {AdtContractActions} action
 * @returns {ContractsState}
 */
export function adtContractsReducer(state = initialState, action: AdtContractActions): ContractsState {
    switch (action.type) {
        case (AdtContractActionTypes.FETCH_CONTRACT_BALANCES):
            return {
                ...state,
                loading: true,
            } as ContractsState;
        case (AdtContractActionTypes.LOAD_AVAILABLE_CONTRACTS):
            return {
                ...state,
                productContracts: { ...state.productContracts, ...action.payload },
            };
        case (AdtContractActionTypes.LOAD_CONTRACT_BALANCES):
            return {
                ...state,
                contractBalances: { ...state.contractBalances, ...action.payload },
                loading: false,
            } as ContractsState;
        case (AdtContractActionTypes.LOAD_CONTRACT_SELECTED):
            return {
                ...state,
                contractSelected: {...action.payload},
            } as ContractsState;
        case (AdtContractActionTypes.RESET):
            return {
                ...initialState,
            } as ContractsState;
        default: {
            return state;
        }
    }
}
